/* Sher-E-Punjab: product description polish (display only, wording unchanged).
   Descriptions use short ALL-CAPS paragraphs as section titles, often with a
   leading emoji ("✨ SET INCLUDES – 6 PIECES"), and feature lists written as
   "✔️ line<br>✔️ line" inside one paragraph. Turn those into a styled heading
   and a proper tick list. */
(function () {
  var TICK = /^\s*(?:✔|✅|☑|✓)️?\s*/;

  function lines(p) {
    var out = [''];
    p.childNodes.forEach(function walk(n) {
      if (n.nodeName === 'BR') { out.push(''); return; }
      if (n.nodeType === 3) { out[out.length - 1] += n.textContent; return; }
      n.childNodes.forEach(walk);
    });
    return out.map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function polish(root) {
    root.querySelectorAll('.halo-text-format p').forEach(function (p) {
      if (p.dataset.spcChecked) return;
      p.dataset.spcChecked = '1';

      var ls = lines(p);
      if (ls.length && ls.every(function (l) { return TICK.test(l); })) {
        var ul = document.createElement('ul');
        ul.className = 'spc-ticks';
        ls.forEach(function (l) {
          var li = document.createElement('li');
          li.textContent = l.replace(TICK, '');
          ul.appendChild(li);
        });
        p.replaceWith(ul);
        return;
      }

      var text = p.textContent.trim();
      var core = text.replace(/^[^A-Za-z0-9]+/, '');
      var letters = core.replace(/[^A-Za-z]/g, '');
      if (!core || core.length > 60 || letters.length < 3) return;
      if (letters !== letters.toUpperCase()) return;
      p.classList.add('spc-desc-h');
      if (core !== text) p.textContent = core;
    });
  }
  function run() { polish(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
